import { render, staticRenderFns } from "./layout-box-simple.vue?vue&type=template&id=30065c02&functional=true"
import script from "./layout-box-simple.vue?vue&type=script&lang=js"
export * from "./layout-box-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports